import React, { useState } from "react";
// import moment from "moment";
import DateSelect from "../../../commonComponents/DateSelect";

export default function MetaFieldDate(props) {
  // render() {
  // const { dateFieldValues } = this.state;
  const [value, setMetaDateValue] = useState();

  return (
    <React.Fragment>
      <div>Default value</div>
      <DateSelect
        className="metafield-create-input"
        returnValue={dateValue => {
          setMetaDateValue(dateValue);
          props.setMetaFieldValues({ default: dateValue });
        }}
        selectedDate={value}
        passDefaultDate
      />
    </React.Fragment>
  );
  // }
}
